import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const validateReviewFile = async ({
  file,
  clientId,
}) => {
  const url = `/fundreviewpanel/validate-fundreview-file/${clientId}`;
  const options = {
    config: {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  };

  const formData = new FormData();
  formData.append('file', file);

  return request.uploadFile(url, formData, options);
};

export const importReviews = ({ clientId, payload }) => {
  const url = `/fundreviewpanel/${clientId}/post-fundreviews-bulkupload`;
  return request.post(url, { data: JSON.stringify(payload) });
};
